// extracted by mini-css-extract-plugin
module.exports = {"spinner":"style_spinner__1BA-o"};